<template>
  <div class="page-content ab-tests">
    <AbTests />
    <AbTestGroupUsers />
    <FetchAbTestDataFromProd />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

import util from '@/Utils/util';

const AbTests = defineAsyncComponent(() => import('./AbTest/AbTests.vue') as any);
const AbTestGroupUsers = defineAsyncComponent(() => import('./AbTest/AbTestGroupUsers.vue') as any);
const FetchAbTestDataFromProd = defineAsyncComponent(() => import('./AbTest/FetchAbTestDataFromProd.vue') as any);

util.moveToTop();
</script>
